import React from 'react'
import Header from './Layouts/Header'
import Sidebar from './Layouts/Sidebar'

export default function PushNotify() {
  return (
    <div>
      <>
      <Header/>
      <Sidebar/>
      <div className="page-wrapper bg-wrapper">
  <div className="content">
    <div className="row">
      <div className="col-sm-12">
        <div className="sell-buy-list">
          <ul>
            <li className="active">
              <a href="#">Buy Crypto</a>
            </li>
           
          </ul>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
        </div>
        <div className="buy-crypto-group">
          <form>
            <div className="row">
              <div className="col-xl-4 col-lg-6">
                <div className="form-group bg-hover col-md-12">
                  <label>Select Crypto (Min-value:0.001 BTC)</label>
                  <select className="form-control select">
                    <option selected="">BTC</option>
                    <option>Ethereum</option>
                    <option>Ripple</option>
                    <option>Bitcoin</option>
                    <option>Cardano</option>
                    <option>Litecoin</option>
                    <option>NEO</option>
                    <option>Stellar</option>
                    <option>EOS</option>
                    <option>NEM</option>
                  </select>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6">
                <div className="form-group bg-hover col-md-12">
                  <label>Choose payment method</label>
                  <select className="form-control select">
                    <option selected="">BTC</option>
                    <option>Ethereum</option>
                    <option>Ripple</option>
                    <option>Bitcoin</option>
                    <option>Cardano</option>
                    <option>Litecoin</option>
                    <option>NEO</option>
                    <option>Stellar</option>
                    <option>EOS</option>
                    <option>NEM</option>
                  </select>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6">
                <div className="form-group">
                  <label>Account Password</label>
                  <input type="text" className="form-control " />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="row">
                  <label>Exchange</label>
                  <div className="col-lg-5">
                    <div className="ex-forms">
                      <div className="row">
                        <div className="col-md-5">
                          <div className="form-group bg-hover exchange-bg mb-0">
                            <select className="form-control select">
                              <option selected="">BTC</option>
                              <option>Ethereum</option>
                              <option>Ripple</option>
                              <option>Bitcoin</option>
                              <option>Cardano</option>
                              <option>Litecoin</option>
                              <option>NEO</option>
                              <option>Stellar</option>
                              <option>EOS</option>
                              <option>NEM</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-7">
                          <div className="form-group mb-0 side-input">
                            <input type="text" className="form-control " />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-2 d-flex align-items-center">
                    <button
                      type="button"
                      className="btn btn-primary represh-btn"
                    >
                      <i className="fas fa-exchange-alt" aria-hidden="true" />
                    </button>
                  </div>
                  <div className="col-lg-5">
                    <div className="ex-forms">
                      <div className="row">
                        <div className="col-md-5">
                          <div className="form-group bg-hover exchange-bg mb-0">
                            <select className="form-control select">
                              <option selected="">BTC</option>
                              <option>Ethereum</option>
                              <option>Ripple</option>
                              <option>Bitcoin</option>
                              <option>Cardano</option>
                              <option>Litecoin</option>
                              <option>NEO</option>
                              <option>Stellar</option>
                              <option>EOS</option>
                              <option>NEM</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-7">
                          <div className="form-group mb-0 side-input">
                            <input type="text" className="form-control " />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="buy-crpto-btn mt-4">
                <button className="btn btn-primary submit-btn mb-0">
                  Buy Crypto
                </button>
              </div>
            </div>
          </form>
        </div>
        <div className="recent-buy comman-head">
          <h3>Recent Buying Cryptocurrency</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
          <div className="row">
            <div className="col-md-12">
              <div className="buy-form-crypto mb-0">
                <div className="border-watch mb-2">
                  <div className="row">
                    <div className="col-xl-8  d-flex align-items-center">
                      <div className="status-blk">
                        <div className="row">
                          <div className="col-lg-3">
                            <div className="action-head">
                              <h4>Latest actions </h4>
                              <span>(Showing 01 to 06 of 100)</span>
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group date-border cal-icon">
                              <input
                                type="text"
                                className="form-control datetimepicker"
                                placeholder="DD-MM-YYYY"
                              />
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group date-border cal-icon">
                              <input
                                type="text"
                                className="form-control datetimepicker"
                                placeholder="DD-MM-YYYY"
                              />
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group bg-hover date-border">
                              <select className="form-control select">
                                <option>Status</option>
                                <option>Pending</option>
                                <option>Succes</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-4 d-flex align-items-center">
                      <label className="me-2">SortBy:</label>
                      <div className="form-group date-border sort-by cal-icon me-2">
                        <input
                          type="text"
                          className="form-control datetimepicker"
                          placeholder="DD-MM-YYYY"
                        />
                      </div>
                      <div className="down-range date-border">
                        <a href="javascript:;">
                          <img src="/assets/img/icon/down-icon.svg" alt="" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="table-responsive">
                  <table className="datatable table  custom-table">
                    <thead>
                      <tr>
                        <th>ID No</th>
                        <th>Currency type</th>
                        <th style={{ minWidth: 110 }}>Payment Method</th>
                        <th style={{ minWidth: 110 }}>Amount </th>
                        <th style={{ minWidth: 110 }}>Trade time</th>
                        <th style={{ minWidth: 110 }}>Status</th>
                        <th style={{ minWidth: 90 }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {" "}
                          <a href="javascript:;">#4562665</a>
                        </td>
                        <td>
                          <img
                            src="/assets/img/icon/watch-icon-07.svg"
                            alt="Award"
                            className="me-2"
                          />
                          Ethereum
                        </td>
                        <td>Visa</td>
                        <td className="pay-clr">$ 197,078,267,295</td>
                        <td className="dark-clr">
                          15 May 2022
                          <br />
                          05:30 AM
                        </td>
                        <td>
                          <span className="custom-status active-green">
                            <span className="live-dark me-1" />
                            Pending
                          </span>
                        </td>
                        <td className="text-end">
                          <div className="dropdown dropdown-action">
                            <a
                              href="buy-crypto.html#"
                              className="action-icon dropdown-toggle"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i className="feather-more-vertical" />
                            </a>
                            <div
                              className="dropdown-menu dropdown-menu-right"
                              style={{}}
                            >
                              <a className="dropdown-item" href="javascript:;">
                                <i className="fas fa-pencil-alt m-r-5" /> Edit
                              </a>
                              <a
                                className="dropdown-item"
                                href="javascript:;"
                                data-bs-toggle="modal"
                              >
                                <i className="fas fa-trash-alt m-r-5" /> Delete
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {" "}
                          <a href="javascript:;">#4562665</a>
                        </td>
                        <td>
                          <img
                            src="/assets/img/icon/watch-icon-01.svg"
                            alt="Award"
                            className="me-2"
                          />
                          Ripple{" "}
                        </td>
                        <td>Debit</td>
                        <td className="pay-clr">$ 103,892,495,504</td>
                        <td className="dark-clr">
                          15 May 2022
                          <br />
                          05:30 AM
                        </td>
                        <td>
                          <span className="custom-status active-green">
                            <span className="live-dark me-1" />
                            Pending
                          </span>
                        </td>
                        <td className="text-end">
                          <div className="dropdown dropdown-action">
                            <a
                              href="buy-crypto.html#"
                              className="action-icon dropdown-toggle"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i className="feather-more-vertical" />
                            </a>
                            <div
                              className="dropdown-menu dropdown-menu-right"
                              style={{}}
                            >
                              <a className="dropdown-item" href="javascript:;">
                                <i className="fas fa-pencil-alt m-r-5" /> Edit
                              </a>
                              <a
                                className="dropdown-item"
                                href="javascript:;"
                                data-bs-toggle="modal"
                              >
                                <i className="fas fa-trash-alt m-r-5" /> Delete
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {" "}
                          <a href="javascript:;">#4562665</a>
                        </td>
                        <td>
                          <img
                            src="/assets/img/icon/watch-icon-02.svg"
                            alt="Award"
                            className="me-2"
                          />
                          Cardeno
                        </td>
                        <td>Visa</td>
                        <td className="pay-clr">$ 63,391,183,730</td>
                        <td className="dark-clr">
                          15 May 2022
                          <br />
                          05:30 AM
                        </td>
                        <td>
                          <span className="custom-status active-green">
                            <span className="live-dark me-1" />
                            Pending
                          </span>
                        </td>
                        <td className="text-end">
                          <div className="dropdown dropdown-action">
                            <a
                              href="buy-crypto.html#"
                              className="action-icon dropdown-toggle"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i className="feather-more-vertical" />
                            </a>
                            <div
                              className="dropdown-menu dropdown-menu-right"
                              style={{}}
                            >
                              <a className="dropdown-item" href="javascript:;">
                                <i className="fas fa-pencil-alt m-r-5" /> Edit
                              </a>
                              <a
                                className="dropdown-item"
                                href="javascript:;"
                                data-bs-toggle="modal"
                              >
                                <i className="fas fa-trash-alt m-r-5" /> Delete
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {" "}
                          <a href="javascript:;">#4562665</a>
                        </td>
                        <td>
                          <img
                            src="/assets/img/icon/watch-icon-03.svg"
                            alt="Award"
                            className="me-2"
                          />
                          NEO{" "}
                        </td>
                        <td>Credit</td>
                        <td className="pay-clr">$ 10,901,285,520</td>
                        <td className="dark-clr">
                          15 May 2022
                          <br />
                          05:30 AM
                        </td>
                        <td>
                          <span className="custom-status active-orange">
                            <span className="live-dark me-1" />
                            Pending
                          </span>
                        </td>
                        <td className="text-end">
                          <div className="dropdown dropdown-action">
                            <a
                              href="buy-crypto.html#"
                              className="action-icon dropdown-toggle"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i className="feather-more-vertical" />
                            </a>
                            <div
                              className="dropdown-menu dropdown-menu-right"
                              style={{}}
                            >
                              <a className="dropdown-item" href="javascript:;">
                                <i className="fas fa-pencil-alt m-r-5" /> Edit
                              </a>
                              <a
                                className="dropdown-item"
                                href="javascript:;"
                                data-bs-toggle="modal"
                              >
                                <i className="fas fa-trash-alt m-r-5" /> Delete
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {" "}
                          <a href="javascript:;">#4562665</a>
                        </td>
                        <td>
                          <img
                            src="/assets/img/icon/watch-icon-08.svg"
                            alt="Award"
                            className="me-2"
                          />
                          BTC{" "}
                        </td>
                        <td>Visa</td>
                        <td className="pay-clr">$ 197,078,267,295</td>
                        <td className="dark-clr">
                          15 May 2022
                          <br />
                          05:30 AM
                        </td>
                        <td>
                          <span className="custom-status active-orange">
                            <span className="live-dark me-1" />
                            Pending
                          </span>
                        </td>
                        <td className="text-end">
                          <div className="dropdown dropdown-action">
                            <a
                              href="buy-crypto.html#"
                              className="action-icon dropdown-toggle"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i className="feather-more-vertical" />
                            </a>
                            <div
                              className="dropdown-menu dropdown-menu-right"
                              style={{}}
                            >
                              <a className="dropdown-item" href="javascript:;">
                                <i className="fas fa-pencil-alt m-r-5" /> Edit
                              </a>
                              <a
                                className="dropdown-item"
                                href="javascript:;"
                                data-bs-toggle="modal"
                              >
                                <i className="fas fa-trash-alt m-r-5" /> Delete
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

</>

    </div>
  )
}
